import { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import DatePicker from "react-datepicker";
import * as datePickerLocales from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { formatDsrApiDateTime } from "../../utils";

const RequestClarificationModal = ({
  t,
  lng,
  isOpen,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");
  const [startedAt, setStartedAt] = useState(new Date());
  const [showReasonError, setShowReasonError] = useState(false);
  const [showDateError, setShowDateError] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setReason("");
    setStartedAt(new Date());
    setShowReasonError(false);
    setShowDateError(false);
  }, [isOpen]);

  const handleClose = () => {
    if (isLoading) {
      return;
    }
    onClose();
  };

  const handleConfirm = () => {
    const trimmedReason = reason.trim();
    const hasReason = Boolean(trimmedReason);
    const hasDate = Boolean(startedAt);

    setShowReasonError(!hasReason);
    setShowDateError(!hasDate);

    if (!hasReason || !hasDate) {
      return;
    }

    onConfirm({
      reason: trimmedReason,
      startedAt: formatDsrApiDateTime(startedAt),
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      centered
      size="md"
      backdrop={isLoading ? "static" : true}
    >
      <ModalHeader toggle={handleClose}>{t("Request Clarification")}</ModalHeader>
      <ModalBody>
        <p className="text-muted">
          {t(
            "Mark this request as awaiting additional information or clarification from the requester."
          )}
        </p>
        <FormGroup>
          <Label className="form-label mb-1 text-dark" for="dsr-clarification-started-at">
            {t("Start Date")} *
          </Label>
          <div className="dsr-deadline-modal__date">
            <DatePicker
              locale={datePickerLocales[lng]}
              name="startedAtDate"
              id="dsr-clarification-started-at"
              className="form-control"
              selected={startedAt}
              dateFormat={"dd/MM/yyyy"}
              showTimeSelect={false}
              maxDate={new Date()}
              onChange={(date) => {
                setStartedAt(date);
                if (date) {
                  setShowDateError(false);
                }
              }}
              disabled={isLoading}
            />
          </div>
          {showDateError && (
            <div className="text-danger mt-1">
              {t("This field cannot be blank")}
            </div>
          )}
        </FormGroup>
        <FormGroup className="mb-0">
          <Label className="form-label mb-1 text-dark" for="dsr-clarification-reason">
            {t("Reason (details)")} *
          </Label>
          <Input
            id="dsr-clarification-reason"
            type="textarea"
            className="dsr-deadline-modal__textarea"
            value={reason}
            placeholder={t(
              "Explain what information or clarification is required..."
            )}
            disabled={isLoading}
            onChange={(event) => {
              setReason(event.target.value);
              if (event.target.value.trim()) {
                setShowReasonError(false);
              }
            }}
          />
          {showReasonError && (
            <div className="text-danger mt-1">
              {t("This field cannot be blank")}
            </div>
          )}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleClose} disabled={isLoading}>
          {t("Cancel")}
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? t("Loading...") : t("Start waiting period")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withNamespaces()(RequestClarificationModal);
